define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/comm/GetRequest",
	"csi/sessionActions"
], function(declare,has,csi,Controller,GetRequest,sessionActions) {

	return declare(Controller, {
		postProcessSuccess: function() {
			// summary: logout from app
			sessionActions.logoutAction();
		}
	});
});